<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  

      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
          <!-- 任务人类型 -->
          <!--
          <el-form-item style="width:12%">
          	  <el-select v-model="query.prize" placeholder="领奖人类型" filterable @change="query.ischange=true">
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in prizelists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          -->
          <!-- 任务人关键字 -->
          <el-form-item>
              <el-input placeholder="邀请人姓名 / 手机" v-model="query.prizekey" clearable @change="query.ischange=true"></el-input>
          </el-form-item>
          <!-- 活动时间 -->
          <el-form-item style="width:19%">
		        <el-date-picker
		            v-model="query.date"
		            type="daterange"
		            range-separator="至"
		            start-placeholder="开始日期"
		            end-placeholder="结束日期"
                :unlink-panels="false"
		            value-format="yyyy-MM-dd" @change="query.ischange=true" clearable style="width:100%">
		        </el-date-picker>
	        </el-form-item> 
          <!-- 任务状态 -->
          <el-form-item style="width:12%">
          	  <el-select v-model="query.status" placeholder="请选择活动状态" clearable filterable @change="query.ischange=true">
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in statuslists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <!-- 是否领取奖品 -->
          <!--
          <el-form-item style="width:12%">
          	  <el-select v-model="query.isprize" placeholder="请选择是否领取奖品" clearable filterable @change="query.ischange=true">
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in prizetypelists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          -->
          <!-- 是否发放 -->
          <el-form-item style="width:12%">
          	  <el-select v-model="query.isprizeget" placeholder="请选择是否发放奖品" clearable filterable @change="query.ischange=true">
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in prizegetlists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <!-- 搜索类型 -->
          <el-form-item style="width:12%">
          	  <el-select v-model="query.searchtype" placeholder="关键字搜索类型" clearable filterable @change="query.ischange=true">
              	  <el-option :label="item.name" :key="index" v-for="(item,index) in searchtypelists" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <!-- 搜索关键字 -->
          <el-form-item>
              <el-input placeholder="活动 / 任务名称" v-model="query.searchkey" clearable @change="query.ischange=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="query.loading">
		  	    <el-table-column prop="id" label="id" width="80"></el-table-column>
	          <el-table-column prop="name" label="任务人">
                <template slot-scope="scope">
                  <span style="float:left;width:100%">{{scope.row.truename}}，{{scope.row.phone}}</span>
                  <span style="float:left;width:100%;font-size:12px;color:#999999">邀请人：{{scope.row.invitorrtruename}}，{{scope.row.invitorphone}}</span>
                </template>
            </el-table-column>
            <el-table-column label="活动 - 任务信息" align="left" width="350">
                <template slot-scope="scope">
                  <span style="float:left;width:100%;font-size:13px">{{scope.row.tasktypeinfo}}</span>
                  <span style="float:left;width:100%;font-size:13px">{{scope.row.taskinfo}}</span>
                </template>
            </el-table-column>
            <el-table-column label="任务状态" prop="finishtime" align="center" width="300">
                <template slot-scope="scope">
                  <a @click="checktaskinfos(scope.row)" style="cursor:pointer"><span :style="scope.row.status=='未完成' ? 'float:left;width:100%;font-size:13px;color:#F56C6C' : 'float:left;width:100%;font-size:13px;color:#67C23A' ">{{scope.row.status}}</span></a>
                  <span style="float:left;width:100%;font-size:13px" v-if="scope.row.inputtime!=''">领取时间：（{{scope.row.inputtime}}）</span>
                  <span style="float:left;width:100%;font-size:13px" v-if="scope.row.finishtime!=''">完成时间：（{{scope.row.finishtime}}）</span>
                </template>
            </el-table-column>
            <el-table-column label="领奖信息" prop="finishtime" align="center" width="200">
                <template slot-scope="scope">
                  <a style="cursor:pointer;" @click="getprizeinfo(scope.row)"><span style="float:left;width:100%;font-size:13px">{{scope.row.prize}}</span></a>
                  <span style="float:left;width:100%;font-size:13px">{{scope.row.prizeget}}</span>
                </template>
            </el-table-column>
	          <el-table-column label="操作" width="130" align="center">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="查看已发放奖品信息" placement="top" v-if="scope.row.state==1 && scope.row.prizeget=='已发放'">
                        <el-button type="primary" size="mini" icon="el-icon-document"  circle @click="catchprizeinfos(scope.row)"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="发放奖品" placement="top" v-if="scope.row.state==1 && scope.row.prizeget=='未发放' && scope.row.prize=='送商品'">
                        <el-button type="success" size="mini" icon="el-icon-goods"  circle @click="edittaskstatus(scope.row)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
	      </el-table>
	      <div class="block">
		      <!--分页begin-->
		      <el-pagination @size-change="pageSizeChange" 
              @current-change="pageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="rows">
		      </el-pagination>
		      <!--分页end-->
	      </div>
      </div>


      <!-- 任务信息 -->
      <el-dialog title="任务状态信息" :visible.sync="checktaskDialog" width="35%" top="10vh">
          <el-col :span="24" style="padding-bottom:10px;border-bottom:1px solid #999999">任务状态：{{taskinfos.state}}</el-col>
          <div v-if="taskinfos.tasktype==1 && taskinfos.id > 0" style="padding-top:20px">
            <el-col :span="5" style="font-size:13px;padding:5px 0">id：{{taskinfos.id}}</el-col>
            <el-col :span="10" style="font-size:13px;padding:5px 0">店铺名称：{{taskinfos.name}}</el-col>
            <el-col :span="9" style="font-size:13px;padding:5px 0">系统版本：{{taskinfos.param}}</el-col>
          </div>
          <div v-if="taskinfos.tasktype==2 && taskinfos.id > 0" style="padding-top:20px">
            <el-col :span="5" style="font-size:13px;padding:5px 0">id：{{taskinfos.id}}</el-col>
            <el-col :span="10" style="font-size:13px;padding:5px 0">订单编号：{{taskinfos.name}}</el-col>
            <el-col :span="9" style="font-size:13px;padding:5px 0">实付金额：{{taskinfos.param}}</el-col>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="checktaskDialog=false">取 消</el-button>
          </div>  
      </el-dialog>


      <!-- 奖品信息 -->
      <el-dialog title="奖品信息" :visible.sync="prizeinfoDialog" width="50%" top="10vh">
          <div class="prizegoods" v-if="taskprize.prize==1">
            <div class="prizegoods-img"><img :src="taskprize.thumb=='' ? require('../../assets/default_img_mini.png') : GLOBAL.staticUrl+taskprize.thumb" /></div>
            <div class="prizegoods-name">{{taskprize.goodsname}}</div>
            <div class="prizegoods-infos">规格：{{taskprize.propertyname}}，重量：{{taskprize.weight}} kg</div>
            <div class="prizegoods-infos">价格：<i style="font-style:normal;font-weight:bold;color:rgb(245, 108, 108)">{{taskprize.price}}</i></div>
          </div>
          <div class="prizecounts" style="margin-top:10px" v-if="taskprize.prize==2">优惠券（满 {{taskprize.couponenenough}} 元减 {{taskprize.couponderate}} 元）</div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="prizeinfoDialog=false">取 消</el-button>
          </div>  
      </el-dialog>


      <!-- 发放奖品信息确认 -->
      <el-dialog title="奖品信息" :visible.sync="lasttaskprizeDialog" width="50%" top="10vh">          
          <span style="float:left;width:98%;padding:5px 1%;border-radius:6px;border:1px solid rgba(211, 211, 211, 0.9);background:rgba(211, 211, 211, 0.9);font-size:12px;color:rgb(245, 108, 108);line-height:21px">
              温馨提示：邀请有礼活动商品数量虽有严格限制，但考虑到实际情况会鼓励更多的人来完成任务导致完成任务所需兑换的奖品超出限制或库存不足，遇此情况管理人员可与客户沟通用其它商品替换当前超出限制或库存不足的商品
          </span>
          
          <div class="prizegoods" v-if="taskprize.prize==1" style="margin-top:20px">
            <div class="prizegoods-img"><img :src="taskprize.thumb=='' ? require('../../assets/default_img_mini.png') : GLOBAL.staticUrl+taskprize.thumb" /></div>
            <div class="prizegoods-name">{{taskprize.goodsname}}</div>
            <div class="prizegoods-infos">规格：{{taskprize.propertyname}}，重量：{{taskprize.weight}} kg</div>
            <div class="prizegoods-infos">价格：<i style="font-style:normal;font-weight:bold;color:rgb(245, 108, 108)">{{taskprize.price}}</i></div>
          </div>
          <div class="prizecounts" style="margin-top:10px" v-if="taskprize.prize==2">优惠券（满 {{taskprize.couponenenough}} 元减 {{taskprize.couponderate}} 元）</div>
          <div slot="footer" class="dialog-footer">
              <el-button type="primary" size="small" @click="grantprize">发 放 奖 品</el-button>
              <el-button size="small" @click="prizeinfoDialog=false">取 消</el-button>
          </div>  
      </el-dialog>


      <!-- 已发放商品信息记录 -->
      <el-dialog title="已发放奖品记录" :visible.sync="granprizeinfoDialog" width="65%" top="10vh">
          <div v-if="granprizeinfos.prize==1" style="float:left;width:100%">
            <ul style="float:left;width:100%;padding:10px 0 30px 0;margin:0;border-bottom:1px dashed #dddddd">
              <li style="float:left;width:98%;padding:5px 1%;list-style-type:none;" v-for="(item,index) in granprizeinfos.data" :key="index">
                <span style="float:left;width:20%;font-size:13px;line-height:15px">{{item.documents}}（{{item.status}}）</span>
                <span style="float:left;width:48%;margin-left:2%;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;font-size:13px;line-height:15px">{{item.productname}}</span>
                <span style="float:left;width:13%;margin-left:2%;font-size:13px;line-height:15px">{{item.dis_sell}} x {{item.num}} {{item.unit}}</span>
                <span style="float:left;width:13%;margin-left:2%;font-size:13px;line-height:15px">{{item.type}}</span>
              </li>
            </ul>


            <!-- 物流信息 -->
            <div class="packstyle" v-if="granprizeinfos.shippings.length>0">
              <div style="float:left;width:100%">
                <a v-for="(tt,ii) in granprizeinfos.shippings" :style="tt.isactive==1 ? 'float:left;padding:5px 20px;border-bottom:2px solid #e6a23c;font-size:13px;cursor:pointer' : 'float:left;padding:5px 20px;border-bottom:2px solid #fff;font-size:13px;cursor:pointer' " @click="checkpacklogistics(ii)">{{tt.name}}（单号：{{tt.code}}）</a>
              </div>
              <ul style="padding:0 2%;margin-top:30px;float:left;width:96%" v-for="(tt,ii) in granprizeinfos.shippings" v-if="tt.isactive==1">
                <li v-for="(ttt,iii) in tt.data" style="border-left:2px solid #e4e7ed;" v-if="ttt.isend=='no'">
                  <div class="icon" v-if="iii == 0"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
                  <div class="time" v-if="iii == 0" style="color:red;">{{ttt.content}}</div>
                  <span class="content" v-if="iii == 0" style="color:red">{{ttt.msgTime}}</span>
                  <span class="content" v-if="iii == 0 && tt.operator!=''" style="color:red">操作人：{{ttt.operator}}</span>

                  <div class="icon" v-if="iii > 0"><img src="../../assets/time.png" /></div>
                  <div class="time" v-if="iii > 0">{{ttt.content}}</div>
                  <span class="content" v-if="iii > 0">{{ttt.msgTime}}</span>
                  <span class="content" v-if="iii > 0 && ttt.operator!=''">操作人：{{tt.operator}}</span>
                </li>
                <li v-for="(ttt,iii) in tt.data" v-if="ttt.isend=='yes'">
                  <div class="icon" v-if="iii == 0" style="color:red"><span style="float:left;width:.8rem;height:.8rem;border-radius:50%;background:red;border:.2rem solid #ddd"></span></div>
                  <div class="time" v-if="iii == 0" style="color:red">{{ttt.content}}</div>
                  <span class="content" v-if="iii == 0" style="color:red">{{ttt.msgTime}}</span>
                  <span class="content" v-if="iii == 0 && tt.operator!=''" style="color:red">操作人：{{ttt.operator}}</span>

                  <div class="icon" v-if="iii > 0"><img src="../../assets/time.png" /></div>
                  <div class="time" v-if="iii > 0">{{ttt.content}}</div>
                  <span class="content" v-if="iii > 0">{{ttt.msgTime}}</span>
                  <span class="content" v-if="iii > 0 && ttt.operator!=''">操作人：{{ttt.operator}}</span>
                </li>
              </ul>
            </div>


          </div>
          <div v-if="granprizeinfos.prize==2">
            <ul style="float:left;width:100%;padding:0;margin:0">
              <li style="float:left;width:98%;padding:5px 1%;list-style-type:none;" v-for="(item,index) in granprizeinfos.data" :key="index">
                <span style="float:left;width:20%">{{item}}</span>
              </li>
            </ul>
          </div>

          <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="granprizeinfoDialog=false">取 消</el-button>
          </div>  
      </el-dialog>     


     
  </div>
  </transition>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
export default {
  components: {
    quillEditor,
  },
  data () {
    return {
        url:this.GLOBAL.domain+"Invitation/index",
        transitionshow:true,
        actionauth:'', //功能权限
        query: {
          act:'inviteeLists',
          token:this.$cookies.get('token'),
          date:[],
          status:'',
          isprize:'',
          isprizeget:'',
          prizekey:'',
          searchtype:'',
          searchkey:'',
          loading:false,
          ischange:false,
        },
        lists:[
          {id:1,prizetype:1,name:'大黄',phone:'18172344987',tasktype:1,activename:'购买系统有奖',taskname:'喊3个人来买系统',prize:1,prizename:'送商品',inputtime:'2021-04-21 09:23:23',finishtime:'',isfinish:1,isapply:0,isprize:0},
          {id:2,prizetype:2,name:'小黄',phone:'13372344987',tasktype:1,activename:'购买系统有奖',taskname:'喊3个人来买系统',prize:1,prizename:'送商品',inputtime:'2021-04-21 09:23:23',finishtime:'2021-04-01 23:10:10',isfinish:2,isapply:1,isprize:1},
          {id:2,prizetype:2,name:'李二狗',phone:'13372344987',tasktype:1,activename:'购买系统有奖',taskname:'喊3个人来买系统',prize:1,prizename:'送商品',inputtime:'2021-04-21 09:23:23',finishtime:'2021-04-01 23:10:10',isfinish:2,isapply:1,isprize:2},
          {id:3,prizetype:1,name:'闰土',phone:'15578990987',tasktype:2,activename:'商城下单有奖',taskname:'喊2个人来下单',prize:2,prizename:'送优惠券',inputtime:'2021-04-21 09:23:23',finishtime:'',isfinish:1,isapply:0,isprize:0},
          {id:4,prizetype:2,name:'蘑菇头',phone:'15578990999',tasktype:2,activename:'商城下单有奖',taskname:'喊2个人来下单',prize:2,prizename:'送优惠券',inputtime:'2021-04-21 09:23:23',finishtime:'2021-04-01 23:10:10',isfinish:2,isapply:1,isprize:1},
          {id:4,prizetype:2,name:'张二麻',phone:'15578990999',tasktype:2,activename:'商城下单有奖',taskname:'喊2个人来下单',prize:2,prizename:'送优惠券',inputtime:'2021-04-21 09:23:23',finishtime:'2021-04-01 23:10:10',isfinish:2,isapply:1,isprize:2},
        ],
        rows:10,

        statuslists:[
          {id:1,name:'未完成任务'},
          {id:2,name:'已完成任务'},
        ],
        prizetypelists:[
          {id:1,name:'未领取奖品'},
          {id:2,name:'已领取奖品'},
        ],
        prizelists:[
          {id:1,name:'邀请人'},
          {id:2,name:'被邀请人'},
        ],
        searchtypelists:[
          {id:1,name:'按活动名称搜索'},
          {id:2,name:'按任务名称搜索'}
        ],
        prizegetlists:[
          {id:1,name:'未发放'},
          {id:2,name:'已发放'}
        ],

        checktaskDialog:false,
        prizeinfoDialog:false,
        taskinfos:[],
        taskprize:[],
        lasttaskprizeDialog:false,
        invitorid:'',
        granprizeinfoDialog:false,
        granprizeinfos:[],

        
    }
  },
  
  mounted(){
    this.getactionauth();
    this.getList(); //查询邀请活动信息
  },
  
  methods:{

    /** 获取功能权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
      this.actionauth=data;
    },
    
    //查询邀请活动信息
    getList() {
        if(this.query.ischange) {
          this.query.p=1;
          this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading = false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.rows=parseInt(res.data.count);
                this.query.loading = false;
                if(this.query.ischange) this.query.ischange=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.query.loading = false;
        });
    },

    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },


    /** 查看任务状态 **/
    checktaskinfos(item) {
      this.checktaskDialog=true;
      var resource = this.$resource(this.url);
      resource.save({act:'getinvitateeinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.taskinfos = JSON.parse(Base64.decode(res.data.Data));
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });

    },



    /** 获取奖品信息 **/
    getprizeinfo(item) {
      this.prizeinfoDialog=true;
      var resource = this.$resource(this.url);
      resource.save({act:'getinvitateeprize',token:this.$cookies.get('token'),id:item.id}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.taskprize = JSON.parse(Base64.decode(res.data.Data));
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 编辑完成任务 **/
    edittaskstatus(item) {
        this.invitorid=item.id;
        this.lasttaskprizeDialog=true;
        var resource = this.$resource(this.url);
        resource.save({act:'getinvitateeprize',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.taskprize = JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },


    /** 确认发布奖品 **/
    grantprize() {
      var resource = this.$resource(this.url);
      resource.save({act:'granteeprize',token:this.$cookies.get('token'),id:this.invitorid}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.lasttaskprizeDialog=false;
              this.getList(); //查询邀请活动信息
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 查看已获取的奖品信息 **/
    catchprizeinfos(item) {
      this.granprizeinfoDialog=true;
      var resource = this.$resource(this.url);
      resource.save({act:'catchgranteeprizeinfo',token:this.$cookies.get('token'),id:item.id}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.granprizeinfos = JSON.parse(Base64.decode(res.data.Data));
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },


    //切换选择包裹物流单号信息
		checkpacklogistics(ii) {
			var logistics=this.granprizeinfos.shippings;
			logistics.forEach(function(e,i) {
				ii==i ? e.isactive=1 : e.isactive=0;
			});
		},


  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.prizegoods {float:left;width:100%}
.prizegoods-img {float:left;width:60px;height:60px;padding:2px;border:1px solid #dddddd;border-radius:6px;background:rgba(221,221,221,.3)}
.prizegoods-img img  {float:left;width:60px;border-radius:6px}
.prizegoods-name {float:left;width:70%;font-size:14px;color:#333336;margin-left:2%;line-height:25px}
.prizegoods-infos {float:left;width:70%;font-size:13px;color:#999999;margin-left:2%;line-height:23px}
.prizecounts {float:left;width:100%;font-size:14px;line-height:25px}
</style>


// WEBPACK FOOTER //
// src/components/mall/Offersinvitateelog.vue